import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

const SIZES = {
  NONE: 'shortcut icon',
  32: 'icon',
  57: 'icon',
  76: 'icon',
  96: 'icon',
  128: 'icon',
  192: 'icon',
  228: 'icon',
  196: 'shortcut icon',
  120: 'apple-touch-icon',
  180: 'apple-touch-icon'
};

const GetNameForSize = (path, size) => {
  try {
    const [ match, prefix='', name, extension ] = /(.+)?\/([a-z0-9_-]+)\.([a-z0-9]+$)/i.exec(path);
    return `${prefix}/${name}${size!=='NONE'?'-'+size:''}.${extension}`;
  } catch (e) {
    return path;
  }
};

const Favicons = ({ path='' }) => (
  <Helmet>
    {Object.keys(SIZES).map(size=>(
      <link key={size} rel={SIZES[size]} href={GetNameForSize(path, size)} sizes={size&&size!=='NONE'?`${size}x${size}`:undefined}/>
    ))}
  </Helmet>
);

Favicons.propTypes = {
  path: PropTypes.string.isRequired
};

export default Favicons;
